import Button from '@srcDS/js/components/atoms/button';
import PrimaryLoader from '@srcDS/js/components/atoms/primaryLoader/PrimaryLoader';
import LocationStroke from '@srcDS/js/components/atoms/icons/LocationStroke';
import { Select } from '@srcDS/js/components/atoms/select';
import { TextField } from '@srcDS/js/components/atoms/textField/TextField';
import styles from './FindStoreForm.module.scss';
import {
  SizeOptions,
  StoreList,
} from '@srcDS/js/components/organisms/findStoreDrawer/types';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

const FindStoreForm = ({
  selectedSize,
  sizeOptions,
  sizeRegister,
  onSubmitAction,
  preferredPostcode,
  getUserPosition,
  onChangeVariant,
  setActiveOption,
  selectVariant,
  isSelectingSize,
  loading,
  setLocationError,
  setSizeValue,
  setFilteredStores,
}) => {
  const { register, handleSubmit, setValue } = useForm();
  const [postCode, setPostCode] = useState(preferredPostcode);
  const defaultValue = isSelectingSize ? null : selectedSize.sku;

  useEffect(() => {
    setValue('postCode', postCode);
  }, [postCode]);

  const setUserPostCode = () => {
    setPostCode(null);
    getUserPosition(setLocationError, setPostCode);
  };

  return (
    <form className={styles.form} onSubmit={handleSubmit(onSubmitAction)}>
      <div className={styles.formBlock}>
        <Select
          name="size3"
          onChange={(e) => {
            let selected;
            selected = sizeOptions.find((el) => el.value === e.target.value);

            setSizeValue('size', e.target.value);
            setSizeValue('size1', e.target.value);
            setSizeValue('size2', e.target.value);

            onChangeVariant(selected.sku);
            selectVariant(selected);
            setActiveOption(selected);
          }}
          defaultValue={defaultValue}
          variant="normal"
          className={styles.sizeOptionSelect}
          ref={sizeRegister}
          isRequired
          isPlaceholder={true}
          selectHeight="50px"
        >
          {sizeOptions.map(({ value, label, isOutOfStock }, index) => (
            <Select.Option
              key={value + label}
              index={index}
              label={label}
              isOutOfStock={isOutOfStock}
              value={value}
              htmlContent={<span>{label}</span>}
            />
          ))}
        </Select>
        <div className={styles.postSearchBlock}>
          <TextField
            className={styles.postSearchInput}
            type="text"
            variant="standard"
            {...register('postCode')}
            onChange={(e) => {
              setFilteredStores([]);
            }}
            isRequired
            isDisabled={loading}
            iconAfter={
              <div className={styles.postSearchIcon} onClick={setUserPostCode}>
                {loading ? (
                  <PrimaryLoader mode="segment" theme="dark" size={40} />
                ) : (
                  <LocationStroke />
                )}
              </div>
            }
          />
        </div>
      </div>

      <Button
        className={styles.btn}
        data-submit-find-store="submit_find_store"
        variant="primaryOutlined"
        as="button"
        type="submit"
      >
        Find in store
      </Button>
    </form>
  );
};

export default FindStoreForm;
